<div *ngIf="message" class="messageContent">
    <div class="grid-x align-middle align-justify">
        <h2 class="messageContent-subject">{{message.subject}}</h2>
        <span class="messageContent-date">{{message.sentDate | date:'short':'':'fr-FR'}}</span>
    </div>

    <hr class="messageContent-separator">

    <div class="grid-x align-middle align-justify">
        <span class="cell shrink messageContent-sender"><span [i18nKey]="'mail.box.new.message.sender'"></span> <b>{{message.author.person.firstName}} {{message.author.person.lastName}}</b></span>
        <div class="cell shrink grid-x" *ngIf="displayActions">
            <button (click)="onAnswerTo()" class="cell shrink messageContent-action"><i class="fas fa-reply"></i></button>
            <button (click)="onDeleteMessage()" class="cell shrink messageContent-action"><i class="far fa-trash-alt"></i></button>
        </div>
    </div>

    <kiwi-spacer [size]="16"></kiwi-spacer>

    <div class="messageContent-text" [innerHtml]="message.content"></div>
</div>
